// src/analytics.js
import ReactGA from 'react-ga4'

const GA_MEASUREMENT_ID = 'G-B6EB2RCHQ2' // <-- replace with your real ID

let initialized = false

export const initGA = () => {
  if (initialized) return
  console.log('Initializing Google Analytics with ID:', GA_MEASUREMENT_ID)
  ReactGA.initialize(GA_MEASUREMENT_ID)
  initialized = true
  console.log('Google Analytics initialized')
}

export const sendPageView = (path) => {
  console.log('Sending page view for path:', path)
  if (!initialized) {
    initGA()
  }

  ReactGA.send({
    hitType: 'pageview',
    page: path
  })
}

export const trackEvent = (action, params = {}) => {
  console.log('Tracking event:', action, params)
  if (!initialized) {
    initGA()
  }

  ReactGA.event({
    action,
    ...params
  })
}
